// ─────────────────────────────────────────────────────────────────────────────
// Liste des villes/préfectures de Guinée
// ─────────────────────────────────────────────────────────────────────────────
// Source : découpage administratif officiel (33 préfectures + 5 communes de
// Conakry). Conakry est placée en tête pour servir de valeur par défaut.
// Les villes sont regroupées par région naturelle pour l'affichage dans un
// <select optgroup="…">, ce qui rend la sélection beaucoup plus rapide qu'une
// longue liste à plat.
// ─────────────────────────────────────────────────────────────────────────────

export const VILLES_GUINEE_PAR_REGION = {
  'Conakry (Capitale)': [
    'Conakry',
    'Kaloum',
    'Dixinn',
    'Matam',
    'Ratoma',
    'Matoto',
  ],
  'Basse-Guinée (Maritime)': [
    'Boké',
    'Boffa',
    'Forécariah',
    'Coyah',
    'Dubréka',
    'Fria',
    'Gaoual',
    'Kindia',
    'Koundara',
    'Télimélé',
  ],
  'Moyenne-Guinée (Fouta Djallon)': [
    'Labé',
    'Dalaba',
    'Koubia',
    'Lélouma',
    'Mali',
    'Mamou',
    'Pita',
    'Tougué',
  ],
  'Haute-Guinée': [
    'Kankan',
    'Dabola',
    'Dinguiraye',
    'Faranah',
    'Kérouané',
    'Kouroussa',
    'Mandiana',
    'Siguiri',
  ],
  'Guinée Forestière': [
    'Nzérékoré',
    'Beyla',
    'Guéckédou',
    'Kissidougou',
    'Lola',
    'Macenta',
    'Yomou',
  ],
};

// Liste à plat (utile pour la validation ou un filtre)
export const VILLES_GUINEE = Object.values(VILLES_GUINEE_PAR_REGION).flat();
